import { useEffect, useRef } from 'react'
import { WARNING_THRESHOLD, ACTIVITY_EVENTS } from '../../utils/sessions'
import { useAuthState } from '../store/useAuthState'

export default function useSessionTimeout() {
    const { setSessionTimeOut, setShowTimeoutWarning } = useAuthState()

    const lastActivityRef = useRef<number>(Date.now())
    const warningTimeoutRef = useRef<NodeJS.Timeout | null>(null)
    const logoutTimeoutRef = useRef<NodeJS.Timeout | null>(null)

    const clearAllTimeouts = () => {
        if (warningTimeoutRef.current) clearTimeout(warningTimeoutRef.current)
        if (logoutTimeoutRef.current) clearTimeout(logoutTimeoutRef.current)
    }

    const scheduleTimeouts = () => {
        clearAllTimeouts()

        const sessionTimeout = sessionStorage.getItem('sessionTimeOut')
        const now = Date.now()

        if (!sessionTimeout) return

        const expiry = new Date(sessionTimeout).getTime()
        const timeLeft = expiry - now

        logoutTimeoutRef.current = setTimeout(() => {
            setSessionTimeOut(true)
        }, timeLeft)

        const timeUntilWarning = timeLeft - WARNING_THRESHOLD
        warningTimeoutRef.current = setTimeout(() => {
            const updatedNow = Date.now()
            const stillInactive = updatedNow - lastActivityRef.current >= expiry - new Date().getTime()

            if (stillInactive) {
                setShowTimeoutWarning(true)
            }
        }, timeUntilWarning)
    }

    useEffect(() => {
        const updateActivity = () => {
            lastActivityRef.current = Date.now()
        }

        ACTIVITY_EVENTS.forEach(e => window.addEventListener(e, updateActivity))

        scheduleTimeouts()
        const interval = setInterval(scheduleTimeouts, 1000)
        window.addEventListener('focus', scheduleTimeouts)

        return () => {
            ACTIVITY_EVENTS.forEach(e => window.removeEventListener(e, updateActivity))
            clearInterval(interval)
            clearAllTimeouts()
            window.removeEventListener('focus', scheduleTimeouts)
        }
    }, [setSessionTimeOut, setShowTimeoutWarning])
}
